import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { isServerConfigurationLoaded } from 'ish-core/store/core/server-config';
import { mapToPayload, mapToPayloadProperty, whenTruthy } from 'ish-core/utils/operators';
import { map, mergeMap, switchMap } from 'rxjs';
import { loadDotCmsContentlet } from '../dotcms-contentlets/dotcms-contentlets.action';
import {
  loadDotCmsConfigurableContent,
  loadDotCmsConfigurableContentSuccess,
} from './dotcms-configurable-contents.action';
import { getCurrentConfigurationContent } from './dotcms-configurable-contents.selectors';

@Injectable()
export class DotCmsConfigurableContentsEffects {
  constructor(private actions$: Actions, private store: Store) {}

  loadDotCmsConfigurableContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDotCmsConfigurableContent),
      mapToPayloadProperty('contentKey'),
      mergeMap(payload =>
        this.store.pipe(
          select(isServerConfigurationLoaded),
          whenTruthy(),
          map(() => payload)
        )
      ),
      switchMap(contentKey =>
        this.store.pipe(
          select(getCurrentConfigurationContent(contentKey)),
          whenTruthy(),
          map(identifier => loadDotCmsConfigurableContentSuccess({ contentKey, identifier }))
        )
      )
    )
  );

  loadDotCmsConfigurableContentData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDotCmsConfigurableContentSuccess),
      mapToPayload(),
      map(payload => loadDotCmsContentlet({ identifier: payload.identifier, depth: payload.depth }))
    )
  );
}
